import { DASHBOARD_SOCIAL_VIEW, DASHBOARD_ADVANCEDTV_VIEW, DASHBOARD_SITEDIRECT_VIEW, DASHBOARD_YOUTUBE_VIEW, DASHBOARD_LABS_VIEW, DASHBOARD_LABS_CC_VIEW, DASHBOARD_LABS_RV_VIEW, DASHBOARD_LABS_HYPERLOCAL_VIEW } from 'constants/capabilities';
import { supportedChannelDisplayNamesKeyed } from 'helpers/channels';

exports.SideBarObjects = [
    {
        name: 'Channels',
        type: 'category'
    },
    {
        name: 'Summary',
        icon: 'icon-summary',
        path: '/dashboard/{entityId}/summary',
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.tv,
        channel: 'tv',
        icon: 'icon-tv-fill',
        path: '/dashboard/{entityId}/channel/tv',
        scope: DASHBOARD_ADVANCEDTV_VIEW,
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.audio,
        channel: 'audio',
        icon: 'icon-audio-fill',
        path: '/dashboard/{entityId}/channel/audio',
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.display,
        channel: 'display',
        icon: 'icon-display-fill',
        path: '/dashboard/{entityId}/channel/display',
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.mobile,
        channel: 'mobile',
        icon: 'icon-mobile-fill',
        path: '/dashboard/{entityId}/channel/mobile',
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.native,
        channel: 'native',
        icon: 'icon-native-fill',
        path: '/dashboard/{entityId}/channel/native',
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.sem,
        channel: 'sem',
        icon: 'icon-sem-fill',
        path: '/dashboard/{entityId}/channel/sem',
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.site,
        channel: 'site',
        icon: 'icon-site-fill',
        path: '/dashboard/{entityId}/channel/site',
        scope: DASHBOARD_SITEDIRECT_VIEW,
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.social,
        channel: 'social',
        icon: 'icon-social-fill',
        path: '/dashboard/{entityId}/channel/social',
        scope: DASHBOARD_SOCIAL_VIEW,
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.youtube,
        channel: 'youtube',
        icon: 'icon-youtube-fill',
        path: '/dashboard/{entityId}/channel/youtube',
        scope: DASHBOARD_YOUTUBE_VIEW,
        type: 'link'
    },
    {
        name: supportedChannelDisplayNamesKeyed.video,
        channel: 'video',
        icon: 'icon-video-fill',
        path: '/dashboard/{entityId}/channel/video',
        type: 'link'
    },
    {
        name: 'Labs',
        isInternal: true,
        type: 'category',
        scope: DASHBOARD_LABS_VIEW,
    },
    {
        name: 'RV Attribution',
        path: '/dashboard/{entityId}/labs/realvalue',
        scope: DASHBOARD_LABS_RV_VIEW,
        type: 'link'
    },
    {
        name: 'Multi-Channel Lift',
        path: '/dashboard/{entityId}/labs/cross-channel/all',
        scope: DASHBOARD_LABS_VIEW,
        type: 'link'
    },
    {
        name: 'ATV Cross Channel Lift',
        path: '/dashboard/{entityId}/labs/cross-channel/atv',
        scope: DASHBOARD_LABS_CC_VIEW,
        type: 'link'
    },
    {
        name: 'Hyperlocal Insights',
        path: '/dashboard/{entityId}/labs/hyperlocal',
        scope: DASHBOARD_LABS_HYPERLOCAL_VIEW,
        type: 'link'
    },
];



// WEBPACK FOOTER //
// ./src/components/pages/config/DashboardSideBarObjects.js